import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { BranchStltMtdImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/index';

@Injectable({
    providedIn: 'root'
})
export class BranchStmtMtdFileImportHelperService extends BaseApiTemplateService<BranchStltMtdImportFileHelperContainerModel> {
 
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/branch-settlement-method-import-file-helper/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/branch-settlement-method-import-file-helper/backoffice-ep';
        this.httpClient = http;
    }
}
